<style scoped lang="less">
    @import "assets/vars.less";
    .gallery {
        &_page {
            position: relative;
        }
        &_info {
            padding: 15px;
            text-align: center;
            > h2 {
                font-weight: 400;
                letter-spacing: 2px;
                color: @dark;
            }
            > p {
                color: @dark_gray;
                font-size: 14px;
                padding: 0 10%;
                line-height: 1.5em;
                letter-spacing: .5px;
            }
        }
    }



    .image-box {
        padding: 0 15px;
    }
    .bgbox {
        margin-bottom: 10px;
        @media (max-width: 700px) {
            margin-bottom: 5px;
        }
        overflow: hidden;
        img {
            width: 100%;

            opacity: 1;
            margin: 0 auto;
            transition: all .3s;
            &:hover {
                opacity: .9;
                width: 103%;
            }
        }
    }

</style>

<template>
    <div>
        <transition name="fade">
            <div class="gallery_page">
                <transition name="fade">
                    <div v-if="loaded" class="gallery_data">
                        <div class="gallery_info">
                            <h2>{{galleryData.pageTitle}}</h2>
                            <div class="monogram"></div>
                            <p>{{galleryData.pageDesc}}</p>
                        </div>

                        <v-gallery :images="galleryData.pics" class="image-box">
                            <masonry :cols="{default: 4, 900: 2, 400: 1}"
                                     :gutter="{default: '15px', 700: '10px'}">
                                <a href="javascript:void(0);"
                                   :data-image="img.big"
                                   v-for="img in galleryData.pics">
                                    <div class="bgbox">
                                        <img :src="img.small">
                                    </div>
                                </a>
                            </masonry>
                        </v-gallery>

                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="!loaded" class="loader">
                        <img v-if="!error" src="./assets/waiting.svg" alt="">
                        <p class="error" v-if="error">Произошла ошибка. Попробуйте позже.</p>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'gallery',
        components: {},
        data () {
            return {
                loaded: false,
                error: false,
                galleryData: {},
            };
        },
        methods: {

            getGallery () {
                axios
                    .get('https://api.paparazzi48.ru/albums/' + this.$route.params.id)
                    .then(response => {
                        if (response.data) {
                            this.loaded = true;
                            this.galleryData = response.data;
                        } else {
                            this.error = true;
                        }
                    })
                    .catch(() => {
                        this.error = true;
                    });
            },
        },
        mounted () {
            if (!this.loaded) {
                this.getGallery();

            }
        },
    };
</script>